import React from "react";
import { socket } from "../../../../lib/socketio";
import { Button, Grid } from "semantic-ui-react";
import Footer from "../../Footer";
import { GroupTemplate } from "../../../Definitions/cl";
import PCSGroupColumn from "../../../Monitor/PCSGroupColumn";
import { Breaker } from "../../../Definitions/GraphicComponents";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentPLC, setUserArray } from "../../../../actions/headerActions";
import { setUser } from "../../../../actions/navActions";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import { GRAPHICS_WRITE, isAuthorized } from "../../../../lib/authorization";

const PCSOvr_S300_MAIN = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);
  let history = useHistory();
  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0) {
      socket.emit("get tag names", [{ display_id: 44 }, { display_id: 1 }]);
      socket.on("receive tag names", (data) => {
        const isFound = data.tags_data.some(
          (element) => element.display_id === 44,
        );
        if (isFound) {
          settags(data.tags_data);
        }
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) =>
    // t.page_name === 'FooterPSM1' ? [t] : []);
    t.display_id === 1 ? [t] : [],
  );

  const x = tags.flatMap((t) => (t.display_id === 44 ? [t] : []));
  const GenTags = x.filter((el) => el.tag_display_subgroup !== "Graphics");

  const display = GenTags.map((t) => t.page_name);
  const GroupTags = GroupTemplate(GenTags, "tag_display_subgroup");

  // 정렬 코드
  const StatusTags = Object.keys(GroupTags[0]).map((i) =>
    GroupTags[0][i].sort((a, b) => parseFloat(a.bit) - parseFloat(b.bit)),
  );

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const pcstags = [];
  let rows;
  const length = GroupTags[0].length; // 7
  rows = Math.round(length / length); // 2 : subGroup 수에 따라 입력

  let i = 0;
  if (length > 0) {
    while (i < length) {
      pcstags.push(GroupTags[0].slice(i, i + rows));
      i += rows;
    }
  }

  const grid = (tag_id, display_name) => (
    <Grid stretched style={{ height: "100%" }}>
      <Grid.Row style={{ marginBottom: "0px", paddingBottom: "0px" }}>
        <Grid.Column
          style={{
            color: data[tag_id] === 1 ? "red" : "white",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          {typeof data[tag_id] !== "undefined" && data[tag_id] !== null
            ? data[tag_id] === 1
              ? "CLOSED"
              : "OPEN"
            : ""}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ paddingTop: "0px", marginTop: "0px" }}>
        <Grid.Column
          style={{
            color: "#fff",
            fontSize: "15px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          {display_name}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );

  const grid_value = (tag_id) => (
    <Grid stretched style={{ height: "100%" }}>
      <Grid.Row style={{ marginBottom: "0px", paddingBottom: "0px" }}>
        {" "}
        {/* value & unit */}
        <Grid.Column
          style={{
            color: "#fff",
            fontSize: "18px",
            marginLeft: "5px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          {typeof tags !== "undefined" &&
          tags !== null &&
          tags.length > 0 &&
          tags.findIndex((x) => x.id === tag_id) !== -1
            ? tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
            : ""}
        </Grid.Column>
        <Grid.Column style={styles.value} name="value">
          {typeof data !== "undefined" &&
          data[tag_id] !== null &&
          typeof data[tag_id] !== "undefined"
            ? data[tag_id].toFixed(2)
            : ""}
        </Grid.Column>
        <Grid.Column style={styles.unit}>
          {typeof tags !== "undefined" &&
          tags !== null &&
          tags.length > 0 &&
          tags.findIndex((x) => x.id === tag_id) !== -1
            ? tags[tags.findIndex((x) => x.id === tag_id)].unit
            : ""}
        </Grid.Column>
      </Grid.Row>
      {/* <Grid.Row style={{paddingTop: '0px', marginTop: '0px'}}>        {/* tag name */}
      {/* <Grid.Column style={{color: '#fff',
                    fontSize: '18px', fontWeight: 'bold', marginLeft: '5px', marginTop: '0px', paddingTop: '0px'
                }}>{(typeof tags !== 'undefined' && tags !== null && tags.length > 0 && tags.findIndex(x => x.id === tag_id) !== -1) ? (tags[tags.findIndex(x => x.id === tag_id)].tag_display_name) : ''}</Grid.Column>
            </Grid.Row> */}
    </Grid>
  );

  // update SOFC, for calculate KWDC Total in PCS Overview page, by sumin 240308 ?
  const getKWDCTotal = (Psm1ID, Psm2ID, Psm3ID, Psm4ID, Psm5ID) => {
    if (typeof data !== "undefined" && data !== null) {
      //&& typeof data[Psm1ID] !== 'undefined' && typeof data[Psm2ID] !== 'undefined' && typeof data[Psm3ID] !== 'undefined' && typeof data[Psm4ID] !== 'undefined' && typeof data[Psm5ID] !== 'undefined'
      data[Psm1ID] = data[Psm1ID] ?? 0; // update 240827, use nullish
      data[Psm2ID] = data[Psm2ID] ?? 0;
      data[Psm3ID] = data[Psm3ID] ?? 0;
      data[Psm4ID] = data[Psm4ID] ?? 0;
      data[Psm5ID] = data[Psm5ID] ?? 0;

      // if(typeof data[Psm1ID] === 'undefined'){
      //     data[Psm1ID] = 0;
      // }else if (typeof data[Psm2ID] === 'undefined'){
      //     data[Psm2ID] = 0;
      // }else if (typeof data[Psm3ID] === 'undefined'){
      //     data[Psm3ID] = 0;
      // }else if (typeof data[Psm4ID] === 'undefined'){
      //     data[Psm4ID] = 0;
      // }else if (typeof data[Psm5ID] === 'undefined'){
      //     data[Psm5ID] = 0;
      // }

      var sum =
        data[Psm1ID] +
        data[Psm2ID] +
        data[Psm3ID] +
        data[Psm4ID] +
        data[Psm5ID];
      return sum;
    }
  };

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <div style={styles.innerdiv}>
        <div style={{ float: "right" }}>
          <div style={styles.menu}>
            <Button
              color="blue"
              content="PCS Faults (MAIN)"
              onClick={(event, value) => history.push("/PCSFaults_MAIN")}
            />
          </div>
        </div>
        <div style={{ textAlign: "center", marginLeft: "13%" }}>
          <h2 style={styles.header}>{display[0]}</h2>
        </div>

        <>
          <div style={styles.div}>
            <svg width="1750" height="500">
              <path
                d="M 35, 100 L 35, 200 L 25, 190 L 35, 190"
                stroke="white"
                strokeWidth={3}
                fill="none"
              />{" "}
              {/* to PSM1 */}
              <text
                x={35}
                y={220}
                font-size={20}
                fontWeight="bold"
                dominant-baseline="middle"
                text-anchor="middle"
                fill="white"
              >
                PSM1
              </text>
              <path
                d="M 175, 100 L 175, 200 L 165, 190 L 175, 190"
                stroke="white"
                strokeWidth={3}
                fill="none"
              />{" "}
              {/* to PSM2 */}
              <text
                x={175}
                y={220}
                font-size={20}
                fontWeight="bold"
                dominant-baseline="middle"
                text-anchor="middle"
                fill="white"
              >
                PSM2
              </text>
              <path
                d="M 315, 100 L 315, 200 L 305, 190 L 315, 190"
                stroke="white"
                strokeWidth={3}
                fill="none"
              />{" "}
              {/* to PSM3 */}
              <text
                x={315}
                y={220}
                font-size={20}
                fontWeight="bold"
                dominant-baseline="middle"
                text-anchor="middle"
                fill="white"
              >
                PSM3
              </text>
              <path
                d="M 455, 100 L 455, 200 L 445, 190 L 455, 190"
                stroke="white"
                strokeWidth={3}
                fill="none"
              />{" "}
              {/* to PSM4 */}
              <text
                x={455}
                y={220}
                font-size={20}
                fontWeight="bold"
                dominant-baseline="middle"
                text-anchor="middle"
                fill="white"
              >
                PSM4
              </text>
              <path
                d="M 595, 100 L 595, 200 L 585, 190 L 595, 190"
                stroke="white"
                strokeWidth={3}
                fill="none"
              />{" "}
              {/* to PSM5 */}
              <text
                x={595}
                y={220}
                font-size={20}
                fontWeight="bold"
                dominant-baseline="middle"
                text-anchor="middle"
                fill="white"
              >
                PSM5
              </text>
              <path
                d="M 35, 100 L 850, 100 "
                stroke="white"
                strokeWidth={3}
                fill="none"
              />{" "}
              {/* top line */}
              <path
                d="M 850, 100 L 980, 100"
                stroke="white"
                strokeWidth={3}
                fill="none"
              />{" "}
              {/* top line to MCCB1*/}
              <path
                d="M 1020, 100 L 1230, 100"
                stroke="white"
                strokeWidth={3}
                fill="none"
              />{" "}
              {/* MCCB1 to MDS1*/}
              <Breaker rect={{ cx: 1235, cy: 100, type: "mds1" }} />{" "}
              {/* MDS1 */}
              <path
                d="M 1270, 100 L 1450, 100"
                stroke="white"
                strokeWidth={3}
                fill="none"
              />{" "}
              {/* MCCB1 to MDS1*/}
              <path
                d="M 850, 100 L 850, 160 "
                stroke="white"
                strokeWidth={3}
                fill="none"
              />{" "}
              {/* top to mccb2 */}
              <Breaker rect={{ cx: 850, cy: 167, type: "mccb2" }} />{" "}
              {/** CB1 -> CB_Aux in S300 */}
              {/* <Breaker rect={{cx: 1150, cy: 167, type: 'mccb3'}} /> CB2 -> S300 deprecated */}
              <path
                d="M 850, 205 L 850, 265 L 920, 265 L 1150, 265 L 1150, 100"
                stroke="white"
                strokeWidth={3}
                fill="none"
              />{" "}
              {/* MCCB2 to ATS1 */}
              {/* <Breaker rect={{cx: 925, cy: 265, type: 'ats1'}} /> ATS1 -> S300 deprecated */}
              <text
                x={1485}
                y={100}
                font-size={20}
                fontWeight="bold"
                dominant-baseline="middle"
                text-anchor="middle"
                fill="white"
              >
                GRID
              </text>
              <Breaker rect={{ cx: 985, cy: 100, type: "mccb1" }} />{" "}
              {/*mccb1 */}
              {/* <path d="M 960, 265 L 1040, 265 " stroke="blue" strokeWidth={3} fill='none'/> MCCB2 to ATS1 */}
              {/* <Breaker rect={{cx: 1045, cy: 265, type: 'ats2'}} /> ATS2 -> S300 deprecated */}
              <path
                d="M 1000, 265 L 1000, 370 "
                stroke="white"
                strokeWidth={3}
                fill="none"
              />{" "}
              {/* ATS1 to LOAD */}
              <text
                x={1000}
                y={390}
                font-size={20}
                fontWeight="bold"
                dominant-baseline="middle"
                text-anchor="middle"
                fill="white"
              >
                AUX LOAD
              </text>
              {/* <path d="M 1080, 265 L 1150, 265 L 1150, 205 " stroke="white" strokeWidth={3} fill='none'/> ATS2 to MCCB3 */}
              {/* <path d="M 1150, 160 L 1150, 100 " stroke="white" strokeWidth={3} fill='none'/> MCCB3 to top line */}
              <text
                x={700}
                y={60}
                font-size={20}
                dominant-baseline="middle"
                text-anchor="middle"
                fill="white"
              >
                kWDC Total
              </text>
              <text
                x={700}
                y={80}
                font-size={15}
                dominant-baseline="middle"
                text-anchor="middle"
                fill="white"
              >
                {getKWDCTotal(29595, 31002, 32409, 33816, 35223).toFixed(2)}
              </text>
              <foreignObject x={980} y={110} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid(4344, "MCB")} {/** MCB_STATUS */}
                </div>
              </foreignObject>
              <foreignObject x={780} y={160} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid(4345, "CB_Aux")} {/** CB1_STATUS */}
                </div>
              </foreignObject>
              {/** CB2_STATUS */}
              {/* <foreignObject x={1170} y = {160} width={150} height={40}>
                                <div style={{height: '100%'}}>
                                    {grid(4346, 'CB2')}  
                                </div>
                            </foreignObject> */}
              {/** ATS1 */}
              {/* <foreignObject x={920} y = {270} width={150} height={40}>
                                <div style={{height: '100%'}}>
                                    {grid(4347, 'ATS1')}  
                                </div>
                            </foreignObject> */}
              {/** ATS2 */}
              {/* <foreignObject x={1040} y = {270} width={150} height={40}>
                                <div style={{height: '100%'}}>
                                    {grid(4348, 'ATS2')}  
                                </div>
                            </foreignObject> */}
              <foreignObject x={1230} y={110} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid(4343, "MDS")} {/** MDS1 */}
                </div>
              </foreignObject>
              <foreignObject x={5} y={240} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(29590)} {/** PSM1_DCCurrentValue */}
                </div>
              </foreignObject>
              <foreignObject x={5} y={260} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(11789)} {/** PSM1_VDC */}
                </div>
              </foreignObject>
              <foreignObject x={5} y={280} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(29595)} {/** PSM1_PCS DC POWER */}
                </div>
              </foreignObject>
              <foreignObject x={145} y={240} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(30997)} {/** PSM2_IDC */}
                </div>
              </foreignObject>
              <foreignObject x={145} y={260} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(21789)} {/** PSM2_VDC */}
                </div>
              </foreignObject>
              <foreignObject x={145} y={280} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(31002)} {/** PSM2_KWDC */}
                </div>
              </foreignObject>
              <foreignObject x={285} y={240} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(32404)} {/** PSM3_IDC */}
                </div>
              </foreignObject>
              <foreignObject x={285} y={260} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(31789)} {/** PSM3_VDC */}
                </div>
              </foreignObject>
              <foreignObject x={285} y={280} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(32409)} {/** PSM3_KWDC */}
                </div>
              </foreignObject>
              <foreignObject x={425} y={240} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(33811)} {/** PSM4_IDC */}
                </div>
              </foreignObject>
              <foreignObject x={425} y={260} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(41789)} {/** PSM4_VDC */}
                </div>
              </foreignObject>
              <foreignObject x={425} y={280} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(33816)} {/** PSM4_KWDC */}
                </div>
              </foreignObject>
              <foreignObject x={565} y={240} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(35218)} {/** PSM5_IDC */}
                </div>
              </foreignObject>
              <foreignObject x={565} y={260} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(51789)} {/** PSM5_VDC */}
                </div>
              </foreignObject>
              <foreignObject x={565} y={280} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(35223)} {/** PSM5_KWDC */}
                </div>
              </foreignObject>
              <foreignObject x={1020} y={320} width={150} height={40}>
                <div style={{ height: "100%" }}>
                  {grid_value(2889)} {/** kWACAUX*/}
                </div>
              </foreignObject>
            </svg>
          </div>
        </>

        <Grid
          width="1800px"
          inverted
          divided
          centered
          columns="equal"
          style={styles.grid}
        >
          <Grid.Column style={{ maxWidth: "1800px" }}>
            <Grid inverted divided centered columns="equal" style={styles.grid}>
              {pcstags.map((c, i) => (
                <PCSGroupColumn index={i} column={c} data={data} option={2} />
              ))}
            </Grid>
          </Grid.Column>
        </Grid>
      </div>
      <Footer tags={FooterTags} data={data} option={"MAIN"} />
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  grid: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  innerdiv: {
    alignItems: "center",
    flex: "1 1 auto",
    paddingBottom: "10px",
    width: "100%",
  },
  menu: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    paddingBottom: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
  },
  value: {
    marginLeft: "30px",
    maginRight: "0px",
  },
  unit: {
    color: "yellow",
    marginLeft: "20px",
  },
};

export default PCSOvr_S300_MAIN;
